rjm.ui.ChartBuilderDropdownView = rjm.ui.ChartBuilderBlockableView.extend(
  handleExternalClickEvent: (e) ->
    if $(e.target).is('.dropdown-toggle, #cbQuickLinks, #cbQuickLinks *')
      e.handled = false
      return e
    @$('#cbQuickLinks').hide()
    e.handled = true
    return e
)